var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 22.9 10 C 23.397 10 23.8 10.403 23.8 10.9 C 23.8 11.397 23.397 11.8 22.9 11.8 C 22.403 11.8 22 11.397 22 10.9 C 22 10.403 22.403 10 22.9 10 Z",
    fill: "rgb(251, 251, 250)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 20.9 12 C 21.397 12 21.8 12.403 21.8 12.9 C 21.8 13.397 21.397 13.8 20.9 13.8 C 20.403 13.8 20 13.397 20 12.9 C 20 12.403 20.403 12 20.9 12 Z",
    fill: "rgb(251, 251, 250)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.9 14 C 19.397 14 19.8 14.403 19.8 14.9 C 19.8 15.397 19.397 15.8 18.9 15.8 C 18.403 15.8 18 15.397 18 14.9 C 18 14.403 18.403 14 18.9 14 Z",
    fill: "rgb(251, 251, 250)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 16.9 16 C 17.397 16 17.8 16.403 17.8 16.9 C 17.8 17.397 17.397 17.8 16.9 17.8 C 16.403 17.8 16 17.397 16 16.9 C 16 16.403 16.403 16 16.9 16 Z",
    fill: "rgb(251, 251, 250)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 14.9 18 C 15.397 18 15.8 18.403 15.8 18.9 C 15.8 19.397 15.397 19.8 14.9 19.8 C 14.403 19.8 14 19.397 14 18.9 C 14 18.403 14.403 18 14.9 18 Z",
    fill: "rgb(251, 251, 250)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 12.9 20 C 13.397 20 13.8 20.403 13.8 20.9 C 13.8 21.397 13.397 21.8 12.9 21.8 C 12.403 21.8 12 21.397 12 20.9 C 12 20.403 12.403 20 12.9 20 Z",
    fill: "rgb(251, 251, 250)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.9 18 C 11.397 18 11.8 18.403 11.8 18.9 C 11.8 19.397 11.397 19.8 10.9 19.8 C 10.403 19.8 10 19.397 10 18.9 C 10 18.403 10.403 18 10.9 18 Z",
    fill: "rgb(251, 251, 250)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.9 16 C 9.397 16 9.8 16.403 9.8 16.9 C 9.8 17.397 9.397 17.8 8.9 17.8 C 8.403 17.8 8 17.397 8 16.9 C 8 16.403 8.403 16 8.9 16 Z",
    fill: "rgb(251, 251, 250)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.73e4b04f6372688149103fabc1771791.svg";
export { ForwardRef as ReactComponent };